package com.artvending.warden

interface GeolocationManager {
	suspend fun getGeolocation(): GeolocationResult?
}


class GeolocationResult(val location: Point?, val errorMessage: String = "")